import React from "react";

const Services = () => {
  return (
    <div className='page'>
      <div className='container'>
        <div className='row'>
          <h3>Fully online DevOps bootcamp with real environments that enables you learn and practice new tools and technology.</h3>
        </div>
      </div>
    </div>
  );
};

export default Services;
